import React, { useState } from 'react';

const QuickPartSelector = ({ parts, onSubmit, onCancel, loading }) => {
  const [selectedPart, setSelectedPart] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!selectedPart) {
      newErrors.selectedPart = 'Veuillez sélectionner une pièce';
    }

    if (!quantity || quantity < 1) {
      newErrors.quantity = 'La quantité doit être supérieure à 0';
    }

    // Vérifier le stock disponible
    if (selectedPart && quantity) {
      const part = parts.find(p => p.id === selectedPart);
      if (part && quantity > part.stock_quantity) {
        newErrors.quantity = `Stock insuffisant (${part.stock_quantity} disponibles)`;
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      const part = parts.find(p => p.id === selectedPart);
      if (part) {
        const partItem = {
          type: 'part',
          part_id: part.id,
          service_id: '',
          description: `${part.name} (Réf: ${part.reference})`,
          quantity: quantity,
          unit_price: part.selling_price || 0,
          total: quantity * (part.selling_price || 0),
          tax_rate: 20
        };
        onSubmit(partItem);
      }
    }
  };

  const handlePartChange = (partId) => {
    setSelectedPart(partId);
    setErrors(prev => ({ ...prev, selectedPart: '' }));
  };

  const handleQuantityChange = (value) => {
    setQuantity(value);
    setErrors(prev => ({ ...prev, quantity: '' }));
  };

  const selectedPartData = parts.find(p => p.id === selectedPart);

  return (
    <div className="modal-overlay">
      <div className="modal-content quick-part-selector">
        <div className="modal-header">
          <h3>Ajouter une pièce</h3>
          <button type="button" className="close-btn" onClick={onCancel}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-group">
              <label htmlFor="part">Pièce *</label>
              <select
                id="part"
                value={selectedPart}
                onChange={(e) => handlePartChange(e.target.value)}
                className={errors.selectedPart ? 'error' : ''}
              >
                <option value="">Sélectionner une pièce...</option>
                {parts.filter(p => p.stock_quantity > 0).map(part => (
                  <option key={part.id} value={part.id}>
                    {part.name} - {part.selling_price}€ (Stock: {part.stock_quantity})
                  </option>
                ))}
              </select>
              {errors.selectedPart && <span className="error-text">{errors.selectedPart}</span>}
            </div>

            {selectedPartData && (
              <div className="part-details">
                <div className="detail-item">
                  <strong>Référence:</strong> {selectedPartData.reference}
                </div>
                <div className="detail-item">
                  <strong>Catégorie:</strong> {selectedPartData.category}
                </div>
                <div className="detail-item">
                  <strong>Prix unitaire:</strong> {selectedPartData.selling_price}€
                </div>
                <div className="detail-item">
                  <strong>Stock disponible:</strong> {selectedPartData.stock_quantity}
                </div>
              </div>
            )}

            <div className="form-group">
              <label htmlFor="quantity">Quantité *</label>
              <input
                type="number"
                id="quantity"
                value={quantity}
                onChange={(e) => handleQuantityChange(parseInt(e.target.value) || 0)}
                min="1"
                max={selectedPartData?.stock_quantity || 999}
                className={errors.quantity ? 'error' : ''}
              />
              {errors.quantity && <span className="error-text">{errors.quantity}</span>}
            </div>

            {selectedPartData && (
              <div className="total-preview">
                <strong>Total: {(quantity * (selectedPartData.selling_price || 0)).toFixed(2)}€</strong>
              </div>
            )}
          </div>

          <div className="modal-actions">
            <button type="button" onClick={onCancel} className="btn-secondary">
              Annuler
            </button>
            <button type="submit" disabled={loading} className="btn-primary">
              {loading ? 'Ajout...' : 'Ajouter la pièce'}
            </button>
          </div>
        </form>

        <style jsx>{`
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
          }

          .modal-content {
            background: white;
            border-radius: 12px;
            width: 90%;
            max-width: 600px;
            max-height: 90vh;
            overflow-y: auto;
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
          }

          .modal-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 24px 24px 0 24px;
            border-bottom: 1px solid #e5e7eb;
            margin-bottom: 24px;
          }

          .modal-header h3 {
            margin: 0;
            font-size: 1.25rem;
            font-weight: 600;
            color: #111827;
          }

          .close-btn {
            background: none;
            border: none;
            color: #6b7280;
            cursor: pointer;
            padding: 4px;
            border-radius: 4px;
            transition: all 0.2s ease;
          }

          .close-btn:hover {
            background: #f3f4f6;
            color: #374151;
          }

          .form-grid {
            padding: 0 24px;
            display: grid;
            gap: 20px;
            margin-bottom: 32px;
          }

          .form-group {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .form-group label {
            font-weight: 500;
            color: #374151;
            font-size: 0.875rem;
          }

          .form-group input,
          .form-group select {
            padding: 12px;
            border: 1px solid #d1d5db;
            border-radius: 6px;
            font-size: 0.875rem;
            transition: border-color 0.2s ease;
          }

          .form-group input:focus,
          .form-group select:focus {
            outline: none;
            border-color: #3b82f6;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
          }

          .form-group input.error,
          .form-group select.error {
            border-color: #ef4444;
          }

          .error-text {
            color: #ef4444;
            font-size: 0.75rem;
            margin-top: 4px;
          }

          .part-details {
            background: #f9fafb;
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            padding: 16px;
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 12px;
          }

          .detail-item {
            font-size: 0.875rem;
            color: #374151;
          }

          .total-preview {
            background: #dbeafe;
            border: 1px solid #93c5fd;
            border-radius: 8px;
            padding: 16px;
            text-align: center;
            font-size: 1.1rem;
            color: #1e40af;
          }

          .modal-actions {
            display: flex;
            justify-content: flex-end;
            gap: 12px;
            padding: 0 24px 24px 24px;
            border-top: 1px solid #e5e7eb;
            margin-top: 24px;
            padding-top: 24px;
          }

          .btn-secondary,
          .btn-primary {
            padding: 10px 20px;
            border-radius: 6px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s ease;
            border: none;
            font-size: 0.875rem;
          }

          .btn-secondary {
            background: #f3f4f6;
            color: #374151;
          }

          .btn-secondary:hover {
            background: #e5e7eb;
          }

          .btn-primary {
            background: #f59e0b;
            color: white;
          }

          .btn-primary:hover:not(:disabled) {
            background: #d97706;
          }

          .btn-primary:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }

          @media (max-width: 640px) {
            .modal-content {
              width: 95%;
              margin: 20px;
            }

            .part-details {
              grid-template-columns: 1fr;
            }

            .modal-actions {
              flex-direction: column;
            }
          }
        `}</style>
      </div>
    </div>
  );
};

export default QuickPartSelector;
